export default __webpack_public_path__ + "static/media/Rage of Xotli.6f455a9d.jpg";